<!-- Header -->
<div class="flex items-center justify-center dialog-header relative">
  {{ type }} Role
  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<!-- Form -->
<div class="dialog-content">
  <form [formGroup]="permissionForm" (ngSubmit)="submit()" class="p-6 space-y-6">
    <div class="flex items-center gap-3">

      <div class="flex-1">
        <label class="font-semibold">Role Name *</label>
        <input pInputText formControlName="name" class="w-full mt-1" />
      </div>

      <div class="flex-1">
        <label class="font-semibold">Status *</label>
        <p-select [options]="['Active', 'Inactive']" formControlName="status" placeholder="Select status"
          class="w-full mt-1"></p-select>
      </div>
    </div>

    <!-- Permissions Panels -->
    <div class="flex space-x-6 mt-4">
      <!-- Left: Module List -->
      <div class="w-1/3 p-4 border rounded shadow">
        <div *ngFor="let module of permissionArray.controls; let i = index" class="mb-4">
          <div [ngClass]="{ 'selected-backgroud': selectedModuleIndex === i, 'text-white': selectedModuleIndex === i }"
            class="flex items-center justify-between cursor-pointer p-5 rounded-sm " (click)="selectModule(i)">
            <p-checkbox [formControl]="getControl(module, 'active')" binary></p-checkbox>
            <span class="ml-2 font-medium">{{ getControl(module, 'title').value }}</span>
          </div>
        </div>

        <p-button label="Add Module" icon="pi pi-plus" (click)="openAddModule()" class="w-full mt-4"></p-button>
      </div>

      <!-- Right: Feature Permissions -->
      <div class="w-2/3 p-4 border rounded shadow" *ngIf="selectedModuleIndex !== null">
        <h3 class="text-lg font-bold mb-4">
          {{ getControl(permissionArray.at(selectedModuleIndex), 'title').value }} - Permissions
        </h3>

        <div [formGroup]="permissionArray.at(selectedModuleIndex)">
          <div formArrayName="features">
            <div *ngFor="let feature of getFeaturesControls(selectedModuleIndex).controls; let j = index"
              [formGroupName]="j" class="mb-4 p-4  shadow-md border-2 rounded-2xl border-gray-100 border-solid">
              <div class="flex justify-between mb-2">
                <span class="font-semibold">{{ getControl(feature, 'title').value }}</span>
                <p-checkbox formControlName="active" binary label="Active"></p-checkbox>
              </div>

              <div class="flex gap-4">
                <label class="font-semibold">Create</label>
                <p-checkbox formControlName="create" binary label="Create"></p-checkbox>
                <label class="font-semibold">update</label>
                <p-checkbox formControlName="update" binary label="Update"></p-checkbox>
                <label class="font-semibold">delete</label>
                <p-checkbox formControlName="delete" binary label="Delete"></p-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Submit -->
    <div class="flex justify-end mt-6">
      <p-button label="Submit" type="submit" [loading]="btnLoading" icon="pi pi-check"
        [disabled]="permissionForm.invalid || btnLoading"></p-button>
    </div>
  </form>
</div>



<ng-container *ngIf="isOpenAddModule">
  <p-dialog [(visible)]="isOpenAddModule" appendTo="body" [modal]="true" [style]="{ width: '50rem' }" [closable]="true">

    <!-- <h2 class="text-lg font-bold"></h2> -->
    <div class="flex items-center justify-center dialog-header relative">
      Add New Module
      <div class="absolute right-2">
        <button (click)="closeIsAddModule()" class="outline-none p-5">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="dialog-content p-6">

      <form [formGroup]="moduleForm" (ngSubmit)="addModule()">
        <!-- Module Title -->
        <div class="mb-3">
          <label class="block font-medium">Module Title</label>
          <input pInputText formControlName="title" placeholder="Enter module title" class="w-full mt-1" />
        </div>

        <!-- Module Name -->
        <div class="mb-3">
          <label class="block font-medium">Module Internal Name</label>
          <input pInputText formControlName="module_name" placeholder="e.g., dashboard, settings" class="w-full mt-1" />
        </div>

        <!-- Features List -->
        <div formArrayName="features" class="space-y-3">
          <div *ngFor="let feature of features.controls; let i = index" [formGroupName]="i" class="border p-3 rounded">
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block">Feature Name</label>
                <input pInputText formControlName="name" placeholder="Internal name (e.g., analytics)" />
              </div>
              <div>
                <label class="block">Feature Title</label>
                <input pInputText formControlName="title" placeholder="Visible title" />
              </div>
            </div>

            <div class="flex gap-4 mt-2">
              <label class="font-semibold">Active</label>
              <p-checkbox formControlName="active" binary label="Active"></p-checkbox>
              <label class="font-semibold">Create</label>
              <p-checkbox formControlName="create" binary label="Create"></p-checkbox>
              <label class="font-semibold">Update</label>
              <p-checkbox formControlName="update" binary label="Update"></p-checkbox>
              <label class="font-semibold">Delete</label>
              <p-checkbox formControlName="delete" binary label="Delete"></p-checkbox>

              <button *ngIf="features.length > 1" type="button" (click)="removeFeature(i)"
                class="ml-auto p-button p-button-danger p-button-sm">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Add Feature Button -->
        <button type="button" class="p-button p-button-text mt-2" (click)="addFeature()">
          <i class="pi pi-plus mr-2"></i>Add Feature
        </button>

        <!-- Submit -->
        <div class="flex justify-end mt-4">
          <button type="submit" class="p-button">Add Module</button>
        </div>
      </form>

    </div>
  </p-dialog>
</ng-container>